import type { SVGProps } from "react";
const SvgGithub = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    fill="none"
    {...props}
  >
    <path
      fill="#24292F"
      fillRule="evenodd"
      d="M13.01 0C5.817 0 0 5.859 0 13.107a13.1 13.1 0 0 0 8.896 12.435c.647.13.884-.282.884-.63 0-.303-.022-1.345-.022-2.43-3.62.782-4.373-1.562-4.373-1.562-.581-1.52-1.443-1.91-1.443-1.91-1.185-.803.086-.803.086-.803 1.314.087 2.004 1.346 2.004 1.346 1.163 1.996 3.037 1.432 3.79 1.085.108-.847.453-1.433.82-1.758-2.887-.304-5.924-1.432-5.924-6.467 0-1.432.516-2.604 1.335-3.516-.13-.325-.582-1.67.13-3.472 0 0 1.098-.347 3.575 1.346a12.5 12.5 0 0 1 3.253-.434c1.098 0 2.218.152 3.252.434 2.478-1.693 3.576-1.346 3.576-1.346.711 1.801.259 3.147.13 3.472.84.912 1.335 2.084 1.335 3.516 0 5.035-3.037 6.141-5.945 6.467.474.412.883 1.193.883 2.43 0 1.758-.022 3.169-.022 3.603 0 .347.238.76.884.63A13.1 13.1 0 0 0 26 13.106C26.02 5.86 20.184 0 13.01 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGithub;